const vi_in_risks_page = {
  address: 'Địa chỉ',
  type: 'Loại',
};
const vi = {
  deposit: 'Nạp',
  Deposit: 'Nạp',
  withdraw: 'Rút',
  Withdraw: 'Rút',
  swap: 'Giao dịch',
  Swap: 'Giao dịch',
  pool: 'Pool',
  Pool: 'Pool',
  pools: 'Pools',
  Pools: 'Pools',
  view_pools: 'Xem pools',
  view_pool: 'Xem pools',
  add_token: 'Thêm Token',
  create_new_pool: 'Tạo pool mới',
  Create_New_Pool: 'Tạo pool mới',
  your_liquidity: 'Pool của bạn',
  Your_Liquidity: 'Pool của bạn',
  farms: 'Farms',
  Farms: 'Farms',
  docs: 'Tài liệu',
  account: 'Tài khoản',
  Discord: 'Discord',
  Telegram: 'Telegram',
  Twitter: 'Twitter',
  connect_to_near: 'Kết nối ví NEAR',
  slippage: 'Độ trượt giá tối đa',
  minimum_received: 'Tối thiểu nhận',
  swap_rate: 'Tỉ giá giao dịch',
  pool_fee: 'Phí giao dịch',
  balance: 'Số dư',
  from: 'Từ',
  to: 'Đến',
  submit: 'Xác nhận',
  view_account: 'Theo dõi tài khoản',
  liquidity: 'Thanh khoản',
  tokens: 'Tokens',
  fee: 'Phí',
  fees: 'Phí',
  details: 'Chi tiết',
  detail: 'Chi tiết',
  minimum_tokens_out: 'Tối thiểu nhận được ',
  pair: 'Cặp thanh khoản',
  tvl: 'TVL',
  add_liquidity: 'Thêm',
  remove_liquidity: 'Gỡ',
  total_liquidity: 'Total thanh khoản',
  my_shares: 'Shares',
  token: 'Token',
  enter_token_address: 'Thêm địa chỉ token',
  remove: 'Gỡ',
  select: 'Chọn',
  select_token: 'Chọn token',
  total_fee: 'Tổng phí % ',
  start_at: 'Bắt đầu vào',
  end_at: 'Kết thúc lúc',
  ended: 'Kết thúc',
  pending: 'PENDING',
  rewards_per_week: 'Token thưởng mỗi tuần',
  apr: 'APR',
  total_staked: 'Tổng staked',
  unclaimed_rewards: 'Phần thưởng chưa nhận',
  claim: 'Nhận',
  claim_all: 'Nhận tất cả',
  stake: 'Stake',
  unstake: 'Unstake',
  your_shares: 'Shares',
  cancel: 'Hủy',
  days: 'ngày',
  slippageCopyForMobile:
    'Độ trượt giá có nghĩa là sự thay đổi giữa số lượng token bạn nhìn trên màn hình với tỉ giá bạn nhận được do có người thực hiện giao dịch trước',
  slippageCopy:
    'Độ trượt giá có nghĩa là sự thay đổi giữa số lượng token bạn nhìn trên màn hình với tỉ giá bạn nhận được do có người thực hiện giao dịch trước',
  swapCopy:
    'Giao dịch trao đổi token được chọn đầu tiên với token <br> thứ hai được chọn. Bể với độ thanh khoản khả dụng cao nhất và phí trao đổi thấp nhất sẽ được sử dụng',
  addTokenCopy: 'Thêm bất kì NEP-141 token',
  farmRewardsCopy:
    'Giá trị biểu thị dựa trên giá và sự thực hiện không thực tế',
  you_do_not_have_enough: 'Bạn không có đủ',
  is_not_exist: 'không tồn tại',
  must_input_a_value_greater_than_zero: 'Phải đưa vào một giá trị lớn hơn 0',
  no_pool_available_to_make_a_swap_from:
    'Không có pool nào khả dụng để thực hiện 1 giao dịch',
  for_the_amount: 'cho khối lượng',
  no_pool_eng_for_chinese: ' ',
  is_not_a_valid_swap_amount: 'Khối lượng giao dịch không hợp lệ',
  not_nep_address:
    'Địa chỉ bạn nhập vào không phải là địa chỉ NEP-141, hãy kiểm tra và nhập lại. Nếu đó là một mainnet contract khác, đi tới Rainbow Bridge để thực hiện quá trình chuyển',
  not_correct_address:
    'Địa chỉ mà bạn nhập vào không đúng, hãy kiểm tra và nhập lại',
  pool_id: 'Pool ID',
  more_pools: 'Nhiều pool hơn',
  my_watchlist: 'Danh sách theo dõi',
  h24_volume: 'Khối lượng giao dịch 24h',
  volume: 'Volume',
  hide_low_tvl_pools: 'Ẩn TVL thấp',
  hide_low_tvl_pools_mobile: 'Ẩn TVL thấp',
  my_watchlist_copy: 'Pool được đánh dấu sẽ xuất hiện ở đây',
  language: 'Ngôn Ngữ',
  deposit_to_add_liquidity: 'Nạp để thêm thanh khoản',
  slip_warn: 'Hãy cẩn thận, kiểm tra tối thiểu bạn có thể nhận',
  slip_invalid: 'Slippage không hộp lệ',
  reward_tokens: 'Token thưởng',
  detail_tip: 'Chi tiết',
  no_data: 'Không có dữ liệu',
  attention: 'Chú ý',
  live: 'Hiện có ',
  ended_search: 'Kết thúc',
  my_farms: 'Farms của bạn',
  sort_by: 'Sắp theo',
  your_farms: 'Hiện Farm',
  new: 'Pool mới',
  unstake_tip_t: 'bạn có phần thưởng chưa nhận...',
  unstake_tip_m:
    'Unstaking sẽ gỡ stake từ tất cả các farm đang hoạt động và chưa quyết định của cùng một cặp.',
  unstake_tip_b: 'Bạn có muốn unstake?',
  value_rewards: 'phần thưởng',
  stake_unstake_tip:
    'Staking hay unstaking sẽ tự động nhận phần thưởng của bạn.',
  over_tip:
    'Để tối ưu hóa phí gas, bạn có thể rút tối đa 4 token cùng một lúc.',
  no_token_tip: 'Không có token thưởng',
  getToken_tip:
    'Bạn có thể nhận token thưởng hoặc  stake LP token của bạn ngay bây giờ!',
  in_farm: 'trong Farm',
  price_impact: 'Tác động giá',
  roi_calculator: 'Tính ROI',
  lp_staked: 'LP Tokens Staked',
  usd: 'USD',
  lp_token: 'LP token',
  stake_for: 'Thời hạn',
  day_1: '1D',
  day_2: '7D',
  day_3: '30D',
  day_4: '90D',
  cur_apr: 'ROI',
  reward_token: 'Token thưởng',
  get_lp_token: 'Lấy LP Shares',
  calculate_roi: 'Tính ROI',
  rewards_claimed: 'Phần thưởng đã được nhận',
  value_rewards_token: 'Gía trị thưởng',
  all: 'Tất cả',
  all_5: '4 tokens một lần',
  more_than: 'Hãy nhập vào số lớn hơn hoặc bằng 0,01',
  less_than: 'Hãy nhập vào số nhỏ hơn 20',
  no_valid: 'Hãy nhập vào số hợp lệ',
  lp_fee: 'Phí cho LP',
  referral_fee: 'Phí giới thiệu',
  protocol_fee_referral_fee: 'Phí giao thức và phí giới thiệu',
  total_fee_create: 'Tổng phí',
  ref: 'REF',
  are_you_sure: 'Bạn đã chắc chưa',
  price_impact_is_about: 'Ảnh hưởng của giá là do',
  yes_swap: 'Trao đổi',
  input_greater_than_available_shares: 'Nhập vào nhiều hơn số shares khả dụng',
  auto_router: 'Router tự động',
  optimal_path_found_by_our_solution: 'Tuyến tối ưu nhất đã được tìm thấy',
  make_sure_you_understand_what_you_do:
    'Hãy đảm bảo rằng bạn hiểu những gì bạn sắp làm',
  filter_by: 'Bộ lọc',
  allOption: 'Tất cả',
  stablecoin: 'Stablecoin',
  near_ecosystem: 'Hệ sinh thái NEAR',
  bridged_tokens: 'Bridged tokens',
  gaming: 'Gaming',
  nft: 'NFT',
  bridge: 'Bridge đến/tới',
  no_result: 'Xin lỗi, chúng tôi không tìm thấy cặp farm nào của bạn',
  multiple: 'Cặp được nhân',
  default: 'mặc định',
  create: 'tạo ra',
  select_a: 'Chọn một',
  wallet: ' ',
  to_use_ref_finance: 'để sử dụng {appName}',
  not_supported: 'không hỗ trợ',
  installed: 'đã cài đặt',
  installe_now: 'cài đặt ngay',
  extension: 'mở rộng',
  first_time_using_ref: 'Lần đầu sử dụng {appName}',
  learn_more: 'Tìm hiểu ngay',
  install_sender_now: 'Cài đặt Sender ngay',
  connect_to_dapps_with_one_click: 'Kết nối tới dApps với một cú click',
  install: 'Cài đặt',
  Connecting: 'Đang kết nối',
  check_sender_wallet_extension: 'Hãy kiểm tra Sender Wallet Extention',
  having_trouble: 'Gặp lỗi?',
  go_back: 'Quay lại',
  web: 'Web',
  Type: 'Kiểu',
  click_to_view: 'Nhấn để xem',
  transaction_failed: 'Giao dịch thất bại',
  wallet_vi: 'ví',
  value: 'giá trị',
  usd_value: 'USD Value',
  initialize_account_tip: 'Vui lòng khởi tạo tài khoản của bạn.',
  support_ledger_tip:
    "Ở bản thiết kế ban đầu, Ledger không thể thực hiện số lượng lớn giao dịch cùng lúc(i.e. Auto Router: trao đổi qua nhiều pool trong một lần) bởi vì sự giới hạn về bộ nhớ. Khi được kích hoạt, tuỳ chọn 'Support Ledger' sẽ giới hạn các giao dịch tới sự đơn giản nhất (dù không có được giá thành tốt nhất), nên các giao dịch của có khối lượng hợp lí mới có thể được thực hiện",
  start: 'bắt đầu',
  max: 'Max',
  ref_account_balance_tip:
    'Có vẻ như đã có một lỗi xảy ra trong quá trình thêm / xóa các pool thanh khoản',
  ref_account_tip_2: 'Bạn có mã thông báo trong Tài khoản REF của mình',
  ref_account_tip_top: 'token(s) của bạn có thể hiện ở trong phần REF Account',
  click_here: 'Bấm vào đây',
  to_recover_them: 'để khôi phục chúng',
  ref_account_tip_3:
    'Để rút token từ Tài khoản REF của bạn vào Ví GẦN của bạn, vui lòng chọn và rút tiền',
  aurora_account_tip_4:
    'Để rút token từ Tài khoản Bản đồ của bạn vào Ví GẦN của bạn, vui lòng chọn và rút tiền',
  buy: 'Mua',
  sell: 'Bán',
  rate: 'tỉ lệ',
  name: 'Tên',
  diff: 'Khác biệt',
  best: 'Tốt nhất',
  awesomeNear_verified_token: 'token được xác nhận bởi AwesomeNear',
  pool_fee_apr: 'Pool fee APY',
  ref_account_balance_tip_mobile:
    'Bạn có mã thông báo trong tài khoản REF của mình.',
  click: 'Nhấp chuột',
  to_recover: 'để phục hồi.',
  rewards_week: 'Rewards/week',
  rewards: 'Rewards',
  claimed_Rewards: 'Nhận phần thưởng',
  POOL: 'POOL',
  lp_Token: 'LP Tokens',
  booster: 'Booster',
  append: 'Append',
  farm: 'Farm',
  status: 'Status',
  Rewards: 'Rewards',
  free: 'Free',
  lp_tokens: 'LP tokens',
  connect_to_wallet: 'Kết nối Wallet',
  slash_policy_content:
    'Each seed has its own slash rate. And it will decreases linearly over time until be 0 at the unlock time of this CD Account.',
  not_expired: 'Not expired',
  accept_pay_slash_tip: 'I accept to pay slash',
  i_will_pay: 'I will pay',
  lp_token_slash: 'LP token exit fee.',
  expired: 'Expired',
  all_4_v2: '4 tokens/lần',
  more_than_seed: 'Input must be greater than or equal to ',
  how_to_earn_more: 'Làm thế nào để gộp phần thưởng?',
  lock_your_lp_tokens_with_booster: 'Lock your LP tokens for boosted rewards',
  unstaked_anytime_no_booster: 'Unstaked anytime, no booster',
  locking_stake: 'Lock-up staking',
  change_to_lock: 'Change to Lock-up staking',
  estimated_rewards: 'Estimated rewards',
  final_booster: 'Final Booster',
  existing_amount: 'Existing amount',
  append_amount: 'Append amount',
  will_be_able_to_unstaked_after: 'will be able to unstaked after',
  you_have: 'Bạn có',
  reward_apr: 'Rewards APR',
  stake_min_deposit: 'Lượng nhập vào phải lớn hơn hoặc bằng ',
  unlock: 'Unlock',
  exit_fee: 'Exit fee',
  end_locking_period: 'End of locking period',
  add_lp_tokens_tip:
    'Bạn cần LP tokens để stake vào một farm tương ứng. Đầu tiên, thê thanh khoản vào pool để nhận LP tokens.',
  slash_tip: 'Exit fee = Exit fee rate * End of locking period * Unlock amount',
  nonBoosted: 'Không được boost ',
  exit_fee_tip: 'Estimated amount you would pay to break your lock-up period',
  forbiddenTip: 'This farm does not support this duration option',
  unstakeTip: 'Staking hoặc unstaking sẽ tự động nhận phần thưởng của bạn.',
  endedFarmsUnstakeTip:
    'Unstaking sẽ xóa phần stake từ tất cả các farms cùng môt cặp đang hoạt động hoặc đang xét duyệt. ',
  comimg: 'Đang đến',
  appendTip: 'Không thể sớm hơn thời gian khóa hiện tại',
  week: 'tuần',
  yours: 'của bạn',
  boost: 'Boost',
  near: 'NEAR',
  eth: 'ETH',
  others: 'Khác',
  stakeLove: 'Stake LOVE',
  unstakeLove: 'Unstake LOVE',
  get_love: 'Nhận LOVE',
  swap_successful: 'Hoán đổi thành công. ',
  trading_successfull: 'Giao dịch thành công. ',
  available_to_stake: 'Lượng stake khả dụng',
  your_assets: 'Tài sản của bạn',
  connect_wallet: 'Kết nối ví',
  disconnect: 'Ngắt kết nối',
  change: 'Thay đổi',
  connect: 'Kết nối',
  veTip:
    'veLP tokens không thể sử dụng để trao đổi, veLPT đại diện cho sức mạnh bình chọn của bạn ',
  loveTip:
    'LOVE tưởng trưng cho thanh khoản veToken. LOVE, giống như bất kì NEP-141 token, trao đổi được và có thể chuyển đổi, pooled, staked and farmed. LOVE đại diện cho thanh khoản cơ bản veTokens của bạn',
  keep_ve: 'giữ',
  months: 'các tháng',
  month: 'tháng',
  lock_lp_tokens: 'Khóa LP Tokens',
  get_lptoken: 'Nhận LP Tokens',
  duration: 'Thời gian',
  ve_lock_tip: 'Không thê sớm hơn thời gian khóa hiện tại',
  get: 'Nhận',
  you_have_no_lp_share: 'Bạn không có LP Tokens',
  lock: 'Khóa',
  locked: 'Đã khóa',
  available: 'Khả dụng',
  in: 'trong',
  filter: 'Bộ lọc',
  options: 'Lựa chọn',
  ratio: 'Tỉ lệ',
  back: 'Quay lại',
  confirm: 'xác nhận',
  total: 'Tổng',
  type: 'Loại',
  connect_to_near_wallet: 'Kết nối tới NEAR Wallet',
  v1Legacy: 'Legacy',
  v2New: 'Classic-New',
  v2_new_farms: 'Classic Farms mới',
  migrate_now: 'Migrate ngay bây giờ!',
  v2_boost_tip:
    'Classic farms sẽ hỗ trợ boosted farms. Legacy farms sẽ chạy phần thưởng <span class="font-bold">1st. Tháng 8, 2022.</span>',
  v2_boost_no_tip:
    'Legacy farms sẽ chạy phần thưởng <span class="font-bold">1st. Tháng 8, 2022.</span>',
  love: 'LOVE',
  Available_to_stake: 'Stake khả dụng',
  you_staked: 'Bạn đã stake',
  has_rewards_tip_in_v2:
    'Tải sản là phần thưởng sẽ được rút trong <a rel="noopener noreferrer nofollow" href="/farms" class="text-sm text-greenColor cursor-pointer underline ml-1 hover:text-senderHot"> Legacy Farms</a>.',
  how_to_get: 'Làm sao để nhận?',
  get_booster: 'Nhận Booster',
  ended_farms: 'kết thúc farms',
  boosted_farms: 'Boosted farms',
  your_farm: 'Farm của bạn',
  your_boosted_farms: 'Boosted farms của bạn',
  search_farms_by_token: 'Tìm farms bằng token',
  search_farms: 'Tìm kiếm farms',
  more_lock_ve_popup2: 'thêm',
  left: 'bên trái',
  create_pool: 'Tạo lập Pool',
  search_by_token: 'Tìm kiếm bằng token',
  your_power: 'Lực của bạn',
  farm_has_boost_tip:
    'Lực của bạn = Staked LP Tokens của bạn * booster (bằng staking LOVE)',
  farm_no_boost_tip: 'Lực của bạn = Staked LP Tokens của bạn',
  more_than_a_simple_pool: 'Nhiều hơn một pool đơn giản',
  ended_Farms: 'Kết thúc Farms',
  vote_capital: 'Bình chọn',
  boostFarmTip: 'Tăng phần thưởng bằng cách staking LOVE',
  boosted: 'Đã boost',
  love_staked: 'Staked LOVE',
  your_apr: 'APR của bạn',
  range_apr: 'Xếp loại hoặc tham khảo APR',
  no_pair_found: 'Không tìm thấy cặp',
  found_stable_pool_in_sauce: 'Đã tìm thấy nhóm ổn định trong SAUCE',
  lp_tokens_locking: ' LP Tokens ',
  you_currently_have: 'Bạn rất muốn ',
  scheduled_to_be_unlocked: 'dự kiến sẽ được mở khóa',
  locking_more_lp_tokens: 'Khóa thêm mã thông báo LP ',
  will_mean_these: 'sẽ có nghĩa là những ',
  lp_tokens_will_not_be_unlocked_until:
    ' Mã thông báo LP sẽ không được mở khóa cho đến khi',
  "I_understand_that_I_won't_be_able_to_remove_my":
    'Tôi hiểu rằng tôi sẽ không thể xóa ',
  until: 'cho đến khi',
  add: 'cộng',
  finish: 'Kết thúc',
  add_custom_network: 'Thêm mạng tùy chỉnh',
  network_name: 'Tên mạng',
  rpc_name_taken_tip: 'Tên mạng đã được sử dụng',
  network_invalid: 'Mạng không hợp lệ',
  fobidden_testnet_rpc_tip:
    'Mạng của máy chủ RPC (testnet) khác với mạng này (mainnet)',
  no_support_testnet_rpc_tip: 'Testnet không hỗ trợ thêm RPC tùy chỉnh',
  stable: 'Stable',
  limit: 'Giới hạn',
  your_active_orders_will_appear_here:
    'Lệnh đang hoạt động của bạn xuất hiện ở đây',
  your_history_orders_will_appear_here:
    'Lịch sử lệnh của bạn sẽ xuất hiện ở đây',
  farm_only: 'Chỉ farm',
  please_confirm_this_transaction_on_ledger:
    'Vui lòng xác nhận giao dịch này trên Ledger',
  limit_order: 'Giới hạn lệnh',
  farm_stop_tip: 'Farm này đã bị dừng.',
  pool_stop_tip: 'Pool này đã bị dừng.',
  volume_24h: 'Volume (24h)',
  add_to_watchlist: 'Thêm vào danh sách xem',
  remove_from_watchlist: 'Xoá khỏi danh sách xem ',
  create_order: 'Tạo lệnh',
  filled: 'Đã đầy',
  canceled: 'Đã huỷ',
  partially_filled: 'Đã đầy một phần',
  pool_composition: 'Cấu tạo của pool',
  amount: 'Số lượng',
  h24_volume_bracket: 'Khối lượng(24h)',
  fee_24h: 'Phí(24h)',
  orders: 'mệnh lệnh',
  your_orders: 'đơn đặt hàng của bạn',
  active: 'Hoạt động',
  history: 'Lịch sử',
  you_sell: 'Bạn bán',
  you_buy: 'Bạn mua',
  fee_tiers: 'Phí các bậc',
  created: 'Đã tạo',
  executed: 'Đã thực hiện',
  actions: 'Các hành động',
  claimed_upper: 'Đã nhận',
  open_my_order: 'Mở',
  initial_order: 'Lệnh ban đầu',
  this_order_has_been_partially_filled: 'Lệnh này đã được làm đầy một phần',
  filled_via_swap: 'Làm đầy thông qua chuyển đổi',
  state: 'Tình trạng',
  partially: 'Một phần',
  near_validation_error: 'Must have 0.5N or more left in wallet for gas fee.',
  near_min_validation_error:
    'Must have 0.2N or more left in wallet for gas fee.',
  no_positons_in_this_pool_yet: 'No positons in this pool yet',
  no_claimed_rewards_yet: 'No claimed rewards yet',
  out_of: 'out of',
  fee_Tiers: 'Phí cấc bậc',
  no_pool: 'Không có pool',
  input_amount: 'Nhập số lượng',
  update_range: 'Cập nhật phạm vị',
  not_enough_balance: 'Không đủ số dư',
  set_price_range: 'Đặt phạm vi giá',
  current_price: 'Giá hiện tại',
  invalid_range_tip:
    'Phạm vi đã chọn không hợp lệ. Giá nhỏ nhất phải thấp hơn giá lớn nhất',
  maket_price_outside_single_only_tip:
    'Giá thị trường nằm ngoài phạm vi giá của bạn. Chỉ đặt vào được tài sản đơn.',
  min_price: 'Giá nhỏ nhất',
  max_price: 'Giá lớn nhất',
  min: 'Nhỏ nhất',
  out_of_range: 'Ngoài phạm vi',
  in_range: 'Trong phạm vi',
  unclaimed_fees: 'Unclaimed Fees',
  your_position_will_be: 'Vị thế của bạn sẽ là',
  at_this_price: 'ở giá này',
  price_range: 'Phạm vi giá',
  positions: 'Các vị thế ',
  position: 'Position',
  range: 'Phạm vi',
  login_risk_tip:
    'Bằng cách chọn vào ô này và tiếp tục, bạn xác nhận rằng bạn hoàn toàn hiểu rõ các rủi ro khi sử dụng {appName}.',
  stable_pool: 'Stable Pool',
  market_rate: 'Tỷ giá thị trường',
  no_token_found: 'Không tìm thấy token.',
  search_name_or_address: 'Tìm kiếm tên hoặc dán địa chỉ...',
  token_address_invalid: 'Địa chỉ token không hợp lệ',
  price_impact_warning: 'Cảnh báo Ảnh hưởng Giá',
  confirm_order: 'Xác nhận Giao dịch',
  you_Sell: 'Bạn Bán',
  to_Buy: 'để Mua',
  at_Price: 'với Giá',
  insufficient_balance: 'Số dư không đủ',
  limitTip: 'Giá của bạn được tự động đặt vào khe giá gần nhất',
  v2_pools: 'Các Pool DCL',
  v2_your_pool_introduction: 'Lưu lượng tập trung được phân đoạn của bạn',
  v1_your_pool_introduction: 'Lưu lượng của bạn trong các pool cổ điển',
  estimate_value: 'Ước tính Giá trị',
  price: 'Giá',
  '@price': '@Giá',
  trades: 'Giao dịch',
  time: 'Thời gian',
  balances: 'Số dư',
  asset: 'Tài sản',
  action: 'Hành động',
  market: 'Thị trường',
  Maker: 'Maker',
  chart: 'Biểu đồ',
  refresh_data_to_continue: 'Vui lòng làm mới dữ liệu để tiếp tục',
  refresh: 'Làm mới',
  both: 'Cả hai',
  All: 'Tất cả',
  Filled: 'Đã Thực Hiện',
  assets: 'Tài sản',
  cancel_order: 'Hủy Lệnh',
  instrument: 'Công cụ',
  dex: 'Dex',
  limit_order_created: 'Lệnh giới hạn đã được tạo',
  limit_order_filled: 'Lệnh giới hạn đã được thực hiện',
  classic_pools: 'Dòng cổ điển',
  active_orders: 'Lệnh hoạt động',
  your_liquidity_usd_value: 'Giá trị thanh khoản của bạn (theo USD)',
  usage: 'Sử dụng',
  holding: 'Giữ',
  your_lp_tokens_and_shares: "Token LP của bạn (Phần')",
  swapped: 'Đã trao đổi',
  dcl_pool: 'Dòng DCL',
  classic: 'Cổ điển',
  classic_farms: 'Trang trại cổ điển',
  locked_in: 'đã khóa trong',
  'deposit_near_tip_0.5':
    'Để gửi tiền, hãy giữ ít nhất 0.5 NEAR để đảm bảo chi phí gas',
  trade: 'Giao dịch',
  earn_2: 'Kiếm',
  portfolio: 'Tài sản',
  more_2: 'Thêm',
  liquidity_pools_2: 'Các Dòng thanh khoản',
  stable_pools: 'Dòng ổn định',
  pool_detail: 'Chi tiết Dòng',
  new_contract_deploy_tip:
    'Một hợp đồng mới đã được triển khai! Vui lòng rút thanh khoản của bạn khỏi hợp đồng cũ',
  remove_will_automatically_claim:
    'Việc rút thanh khoản sẽ tự động nhận phí chưa nhận của bạn.',
  legacy_tip: 'Tìm thấy LP token chưa đặt cược hoặc phần thưởng trong',
  legacy_farms: 'Trang trại cũ',
  all_farms: 'Tất cả trang trại',
  your_farms_2: 'Trang trại của bạn',
  dcl_farms: 'Trang trại DCL',
  farm_type: 'Loại trang trại',
  farm_2: 'Trang trại',
  to_claim: 'Nhận',
  liquidity_staked: 'Thanh khoản đã đặt cược',
  dcl_pool_detail: 'Chi tiết Dòng DCL',
  reward_range: 'Phạm vi phần thưởng',
  reward_range_tip: 'Phần thưởng trang trại trong phạm vi này',
  ending_soon: 'Sắp kết thúc',
  farm_ended_tip: 'Farm đã kết thúc.',
  farm_will_ended_tip: 'Farm sẽ kết thúc sớm.',
  new_farm: 'Farm mới',
  is_coming: 'đang sắp tới',
  est_apr: 'APR Ước tính',
  farming: 'Đang farm',
  unavailable: 'Không khả dụng',
  hide: 'Ẩn',
  show: 'Hiện',
  your: 'Của bạn',
  max_apr: 'APR Tối đa',
  you_can_earn_tip:
    'Bạn có thể kiếm phần thưởng bằng cách farming, ước tính APR là',
  you_can_earn_current_tip:
    'farm bạn đang đặt cược đã kết thúc, và farm mới đang đến, ước tính APR là',
  go_new_farm: 'Đi đến farm mới',
  go_farm: 'Đi đến farm',
  in_ended_farm: 'trong farm đã kết thúc',
  staked: 'Đã đặt cược',
  in_farm_3: 'trong farm',
  estimation: 'Ước tính Giá trị',
  this_staked_tip: 'NFT này đã được đặt cược',
  dcl_liquidity: 'Thanh khoản DCL',
  classic_liquidity: 'Thanh khoản Cổ điển',
  will_appear_here_tip: 'Vị trí thanh khoản của bạn sẽ xuất hiện ở đây.',
  dcl_will_appear_here_tip:
    'Vị trí thanh khoản DCL của bạn sẽ xuất hiện ở đây.',
  classic_will_appear_here_tip:
    'Vị trí thanh khoản Cổ điển của bạn sẽ xuất hiện ở đây.',
  price_range_overlap_ratio: 'Tỷ lệ Phạm vi Giá chồng chéo',
  real_time_executed_orders: 'lệnh thực hiện thời gian thực',
  real_time_executed_orders_tip:
    'Khi đặt một lệnh bán với giá cao hơn giá thị trường hoặc lệnh mua với giá thấp hơn giá thị trường bằng chức năng lệnh giới hạn, {appName} sẽ cố gắng thực hiện hành động trao đổi ngừng điểm trước tiên, và nếu còn bất kỳ số lượng nào, một lệnh giới hạn sẽ được tạo ra để điền vào phần còn lại. Lệnh thực hiện thời gian thực liên quan đến lệnh được đặt bằng chức năng lệnh giới hạn nhưng được thực hiện thông qua giao dịch trao đổi. Trong phần "Lịch sử", bạn có thể xem các lệnh thực hiện thời gian thực giữa lệnh giới hạn hiển thị sớm nhất trong Lịch sử đến thời điểm hiện tại.',
  swapped_history_order: 'Đã trao đổi',
  ledger_guide_tip_1:
    'Để sử dụng ví Ledger của bạn cho các giao dịch một cách thành công, tính năng ',
  ledger_guide_tip_2: 'đã được kích hoạt tự động.',
  ledger_guide_tip_3: 'Vui lòng lưu ý',
  ledger_guide_tip_quote: '"',
  support_ledger_tip_new: '"Hỗ trợ Ledger"',
  ledger_guide_tip_4:
    'rằng do hạn chế của ví Ledger, tỷ lệ hiện tại được cung cấp bởi chức năng trao đổi',
  ledger_guide_tip_5: 'có thể không phải là giá tốt nhất.',
  ledger_guide_tip_6: '.',
  your_trade_route: 'Lộ trình Giao dịch của bạn',
  markets: 'Thị trường',
  exchanges: 'Sàn giao dịch',
  output_est: 'Đầu ra (ước tính)',
  new_swap_order_tip:
    'Giá được cung cấp bởi ứng dụng AMM của {appName} và chỉ để tham khảo. Không có đảm bảo rằng lệnh giới hạn của bạn sẽ được điền ngay lập tức.',
  instants_swap: 'Trao đổi Ngay lập tức',
  swappped: 'Đã trao đổi',
  claimed: 'Đã yêu cầu',
  executing_capital: 'Đang thực hiện',
  trade_route: 'Lộ trình Giao dịch',
  settings: 'Cài đặt',
  no_trade_routes: 'Không có Lộ trình Giao dịch nào',
  steps_in_the_route: 'Bước trong Lộ trình',
  swap_chart_no_data: 'Không đủ dữ liệu cho biểu đồ lúc này.',
  last_updated: 'Cập nhật lần cuối',
  Burrow: 'Burrow',
  Supplied: 'Được cung cấp',
  APY: 'APY',
  top_bin_apr: 'Top Bin APR (24h)',
  size: 'Kích thước',
};
export default Object.assign(vi, vi_in_risks_page);
